import { ConstructionWork as ConstructionWorkApi } from "modules/construction-work/src/Api/ConstructionWorkApi";
import { ChoiceFilter, Filters } from "modules/spravochnik/dt-front-page-generator/src/Entity/Filter";
import { ArrayCollection } from "lib/base/collection";
import { IniData } from "modules/construction-work/src/Entity/IniData";
import { IncidentMap } from "modules/construction-work/src/Entity/Work/IncidentMap";
import { ConstructionWorkMap } from "modules/construction-work/src/Entity/Work/ConstructionWorkMap";
import {
    ConstructionWorkDetailCardMapInterface,
    IncidentDetailCardMapIncident
} from "modules/construction-work/src/Common/interface";
import WorkMapper from "modules/construction-work/src/Entity/Work/WorkMapper";
import IncidentMapper from "modules/construction-work/src/Entity/Work/IncidentMapper";

export class Store {
    public constructionWorksMap: ConstructionWorkMap[] = [];
    public incidentsMap: IncidentMap[] = [];
    public initData: IniData;
    public filters: Filters;
    public baseApp: any;
    public cardDetailConstructionWorks: ConstructionWorkDetailCardMapInterface[] = []
    public cardDetailIncidents: IncidentDetailCardMapIncident[] = []

    constructor(
      private readonly _api: ConstructionWorkApi
    ) {
        this.baseApp = (window as any).BaseApp.initData;
    }

    public async iniWorkForMap(): Promise<void> {
        const response = await this._api.fetchConstructionWorkMap();

        const incidentMapper = new IncidentMapper(this.initData.getGroupsArray());
        const workMapper = new WorkMapper(this.initData.getCategoriesArray());

        const [incidents, works] = await Promise.all([
            Promise.all((response.incident?.objects ?? []).map((incident: {geoObject: string}) => incidentMapper.build(incident))),
            Promise.all((response.works?.objects ?? []).map((work: {geoObject: string}) => workMapper.build(work)))
        ]);
        this.incidentsMap = incidents;
        this.constructionWorksMap = works;
    }

    public async initDataForFilter(): Promise<void> {
        const filterCollection: ArrayCollection<ChoiceFilter> = new ArrayCollection()
        const data = await this._api.initData();
        this.initData = IniData.createByObj(data);
        filterCollection.addItem(new ChoiceFilter('statuses', 'Статус', new Map(this.initData.getStatusesArray().map(obj => [obj.id, obj.name]))));
        filterCollection.addItem(new ChoiceFilter('executors', 'Исполнитель', new Map(this.initData.getExecutorsArray().map(obj => [String(obj.id), obj.name]))));
        filterCollection.addItem(new ChoiceFilter('categories', 'Категория', new Map(this.initData.getCategoriesArray().map(obj => [obj.id, obj.name]))));
        this.filters = new Filters(filterCollection);
    }

    public async fillDataForDetailCardMap(ids: (number | string)[]): Promise<boolean> {
        this.cardDetailIncidents = [];
        this.cardDetailConstructionWorks = [];
        try {
            const promises = [];
            const { numbers, strings } = this.splitIdsSelectedWorks(ids);
            promises.push(numbers?.length ? this._api.fetchSelectedIncidents(numbers) : []);
            promises.push(strings?.length ? this._api.fetchSelectedConstructionWorks(strings) : []);
            const [cardDetailIncidents, cardDetailConstructionWorks] = await Promise.all(promises);
            this.cardDetailIncidents = cardDetailIncidents;
            this.cardDetailConstructionWorks = cardDetailConstructionWorks;
            return true;
        } catch (e) {
            console.log(e.message);
        }
        return false;
    }

    private splitIdsSelectedWorks(ids: (number | string)[]): {numbers: number[], strings: string[]} {
        return ids.reduce((acc: { numbers: number[], strings: string[] }, item: number | string) => {
            if (typeof item === 'number') {
                acc.numbers.push(item);
            } else if (typeof item === 'string') {
                acc.strings.push(item);
            }
            return acc;
        }, { numbers: [], strings: [] });
    }
}
